export const validateStrongPassword = (password) => ({
  hasMinLength: password.length >= 8,
  hasUpperCase: /[A-Z]/.test(password),
  hasNumber: /\d/.test(password),
  hasSpecialCharacter: /[^A-Za-z0-9]/.test(password),
  isValid:
    password.length >= 8
    && /[A-Z]/.test(password)
    && /\d/.test(password)
    && /[^A-Za-z0-9]/.test(password),
});

/**
 * Calculates password strength score.
 *
 * Scoring Rules:
 * +1 Minimum length of 8 characters
 * +1 Contains uppercase letter
 * +1 Contains number
 * +1 Contains special character
 *
 * @param {string} password
 * @returns {number} Strength score from 0-4.
 */
export const getPasswordStrength = (password) => {
  let score = 0;

  if (password?.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  return score;
};
